import React from 'react';
// import ReactDOM from 'react-dom'
import { Line } from 'react-chartjs-2';
import Tooltip from './Tooltip';
import './style.css';

class GraficoSentimento extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showTooltip: false,
            tooltip: {
                estilo: null,
                periodo: null,
                itens: []
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: "top",
                    labels: {
                        padding: 10,
                        fontColor: "#668593",
                        fontSize: 12
                    },
                },
                layout: {
                    padding: {
                        left: 10,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                scales: {
                    yAxes: [
                        {
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: '-   ←   Sentimento   →   +',
                                fontColor: "#668593",
                                fontStyle: "bold",
                                fontFamily: "Helvetica",
                                fontSize: 22
                            },
                            ticks: {
                                display: false
                            },
                            gridLines: {
                                tickMarkLength: 40,
                                drawTicks: true,
                                display: false,
                                drawBorder: false
                            }
                        }
                    ],
                    xAxes: [
                        {
                            gridLines: {
                                zeroLineColor: "transparent",
                                tickMarkLength: 30,
                                drawTicks: true,
                                display: false,
                                drawBorder: false
                            },
                            ticks: {
                                fontColor: "#668593",
                                fontStyle: "bold",
                                fontFamily: "Roboto Mono"
                            }
                        }
                    ]
                },
                tooltips: {
                    // Disable the on-canvas tooltip
                    enabled: false,
                    //custom: geradorTooltip
                }
            }
        };
        this.trataTooltip = this.trataTooltip.bind(this);
    }

    trataTooltip(tooltipModel) {
        // hide the tooltip
        if (tooltipModel.opacity === 0) {
            this.setState({tooltip: {
                    ...this.state.tooltip,
                    estilo: null
                }});
            return;
        }

        const graficoWidth = document.getElementById("container-grafico").clientWidth;

        //const position = ReactDOM
        //    .findDOMNode(this.refs['chart'])
        //    .getBoundingClientRect();

        // Pega o periodo
        const periodo = this.periodos[tooltipModel.dataPoints[0].index];

        // Pega a lista de tooltips
        let margemTop = 8;
        const listaTooltips = tooltipModel.dataPoints.map((dataPoint) => {
            const politico = this.props.dados[dataPoint.datasetIndex];
            const periodoPolitico = politico.periodos.filter(item => item.data === periodo.rotulo)[0];

            margemTop =  Math.max(margemTop, this.popularidade[dataPoint.datasetIndex]
                .filter(popularidade => popularidade.data === periodo.rotulo)[0].raio);

            return {
                nome: politico.nome,
                imagem: politico.imagem,
                popularidade: periodoPolitico.popularidade,
                percentPositivo: (periodoPolitico.popularidade === 0 ? 0 : Math.round(periodoPolitico.positivo / periodoPolitico.popularidade * 100)),
                percentNeutro: (periodoPolitico.popularidade === 0 ? 0 : Math.round(periodoPolitico.neutro / periodoPolitico.popularidade * 100)),
                percentNegativo: (periodoPolitico.popularidade === 0 ? 0 : Math.round(periodoPolitico.negativo / periodoPolitico.popularidade * 100))
            };
        });

        // Seta a posição do tooltip considerando o container
        let left;
        let right;
        if (tooltipModel.caretX > (graficoWidth - 220)) {
            left = "";
            right = 0;
        } else {
            left = tooltipModel.caretX;
            right = "";
        }
        const top = margemTop + tooltipModel.caretY;

        this.setState({tooltip: {
                estilo: {
                    top: top,
                    left: left,
                    right: right,
                    opacity: 0.9,
                    zIndex: 20
                },
                periodo: periodo,
                itens: listaTooltips
            }});
    }

    render () {
        const error = this.props.error;
        const isLoaded = this.props.isLoaded;
        const dados = this.props.dados;

        if (error) {
            return <div className="grafico-historico"> Erro: {error.message} </div>
        } else if (!isLoaded) {
            return <div className="grafico-historico"/>
        } else {
            const labels = dados[0].periodos.map(function (item) {
                return item.data;
            });

            // Algumas definições
            const maxRaioPonto = 20;
            const minRaioPonto = 4;


            const popularidade = dados.map(politico => politico.periodos.map(tweet => tweet.popularidade)).reduce((a, b) => a.concat(b), []);
            const maximo = Math.max(...popularidade);
            //const minimo = Math.min(...popularidade);

            this.popularidade = dados.map(politico =>
                politico.periodos
                    .map(periodo => {
                        let raio = (periodo.popularidade / maximo * maxRaioPonto);
                        if (raio < minRaioPonto) {
                            raio = minRaioPonto;
                        }
                        return {
                            ...periodo,
                            raio: raio
                        };
                    }));

            // Metro UI
            const paleta = ["#ffc425",
                "#d11141",
                "#7911BF",
                "#207501",
                "#F5FBEF",
                "#2176FF",
                "#f37735"
                ];

            let datasetsGrafico = [];

            for (let i = 0; i < dados.length; i++) {
                const politico = dados[i];
                const cor = paleta[i];

                const popularidadeFinal = this.popularidade[i].map(popularidade => popularidade.raio);

                const dataset = {
                    label: politico.nome,
                    borderColor: cor,
                    backgroundColor: cor,
                    pointBorderColor: cor,
                    pointBackgroundColor: cor,
                    pointHoverBackgroundColor: cor,
                    pointHoverBorderColor: cor,
                    pointBorderWidth: 2,
                    pointHoverRadius: popularidadeFinal,
                    pointHoverBorderWidth: 5,
                    pointRadius: popularidadeFinal,
                    pointHitRadius: popularidadeFinal,
                    fill: false,
                    borderWidth: 2,
                    data: politico.periodos.map(periodo => periodo.sentimento)
                };

                datasetsGrafico.push(dataset);
            }

            const data = {
                labels: labels,
                datasets: datasetsGrafico
            };

            const soma = function(a, b) {
                return a+b
            };

            this.periodos = this.props.dados[0].periodos.map(item => item.data).map(data => {

                const totalData = this.props.dados.map(politico =>
                    politico.periodos.filter(periodo => periodo.data === data).map(periodo => periodo.popularidade)[0]).reduce(soma, 0);

                return {
                    rotulo: data,
                    total: totalData
                }
            });

            const tooltipConfig = {
                enabled: false,
                intersect: false,
                mode: 'point',
                custom: this.trataTooltip
            };

            const options = Object.assign({}, this.state.options);
            options.tooltips = tooltipConfig;

            return (
                <div className="grafico-historico">
                    <Line ref='chart' data={data} options={options}/>
                    <Tooltip id="chartjs-tooltip"
                             periodo={this.state.tooltip.periodo}
                             itens={this.state.tooltip.itens}
                             estilo={this.state.tooltip.estilo} style={{right: 0}}
                             cidade={this.props.cidade}/>
                </div>
            )
        }
    }
}

export default GraficoSentimento;


// WEBPACK FOOTER //
// ./src/scenes/Home/components/GraficoSentimento/index.js